var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLesotho(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 8h30v8H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#030a85",
    d: "M30 8H0V0h30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#45994d",
    d: "M30 24H0v-8h30z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M15 8.47q.16 0 .24.14c.57.07.87.48.97.96.12.56 0 1.32-.4 2.12l1.52 2.02.24-.12.56 1.18a6.8 6.8 0 0 1-6.26 0l.56-1.18.24.12 1.52-2.02a3.4 3.4 0 0 1-.4-2.12c.1-.48.4-.9.97-.96a.3.3 0 0 1 .24-.14m.6 2.95c.31-.69.41-1.34.31-1.77-.08-.38-.28-.67-.66-.73v.99l.48.48h-.38v.69zm-.85-2.5c-.38.06-.58.35-.66.73-.1.43 0 1.08.3 1.77l.26-.34v-.7h-.38l.48-.47z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLesotho);
export default __webpack_public_path__ + "static/media/lesotho.3970f9f3ea6b0e23aa641e74c78a7535.svg";
export { ForwardRef as ReactComponent };